//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from "@/components/avatar";
import { api_GetGiftList, api_ReceiveGift, api_ReceiveGiftCDK, getCurrentVipInfo, api_GetVipCases } from "@/api";
import { mapState, mapMutations } from "vuex";
import { conversion } from "@/tool";
import userImg from "@/assets/images/user/ava_none.jpg";
import vipPrice from "./vipPrice";
export default {
  components: {
    "c-avatar": Avatar,
    "c-vip-price": vipPrice,
  },
  data() {
    return {
      lastViplevel: 12,
      userImg,
      vipCondition: [],
      vipUpgradeCases: {},   // usetype=13 升级箱，key=level
      vipWeeklyCases: {},    // usetype=14 周奖励箱，key=level
      vipAddOn: [0.2, 0.88, 1.8, 8, 18, 38, 58, 88, 188, 388, 588, 888],
      vipGift: [
        "4-6",
        "25-28",
        "58-88",
        "128-158",
        "368-388",
        "888-1988",
        "1088-2288",
        "1888-6888",
        "5888-12888",
        "12888-21888",
        "38888-48888",
        "58888-68888",
      ],
      vipRollName: [
        "福利roll房",
        "福利roll房",
        "福利roll房",
        "土豪roll房",
        "土豪roll房",
        "土豪roll房",
        "神豪roll房",
        "神豪roll房",
        "神豪roll房",
        "帝豪roll房",
        "帝豪roll房",
        "帝豪roll房",
      ],
    };
  },
  filters: {
    conversion,
  },
  computed: {
    ...mapState(["user"]),
    nextNeed() {
      if (!this.user.nickname || !this.vipCondition.length) return 0;
      var tnext_need = Number(
        Number(this.vipCondition[this.user.vipLevel] || 0) -
        Number(this.user.spendAmount)
      );
      return tnext_need < 0 ? 1 : tnext_need;
    },
    currentNeed() {
      return (index) => {
        if (!this.user.nickname || !this.vipCondition.length) return 0;
        var tnext_need = Number(
          Number(this.vipCondition[index - 1] || 0) - Number(this.user.spendAmount)
        );
        return tnext_need < 0 ? 1 : tnext_need;
      };
    },
    userAavatar() {
      return this.user.avatar
        ? this.$imgfilter(this.user.avatar)
        : this.userImg;
    },
    userVipIconUrl() {
      return (index) => require("@/assets/images/icon/vip/" + index + ".png");
    },
    vipStepWidth() {
      return (index) => {
        let width = "";
        if (this.user.vipLevel == index) {
          if (index == 12) {
            width = "100%";
          } else {
            width = `${(parseInt(this.user.spendAmount) / this.vipCondition[index]) *
              100
              }%`;
          }
        } else {
          width = "0%";
        }
        return width;
      };
    },
  },
  watch: {},
  created() { },
  async mounted() {
    this.setInfo();
    try {
      const [vipInfoRes, vipCasesRes] = await Promise.all([
        getCurrentVipInfo(),
        api_GetVipCases(),
      ]);
      if ((vipInfoRes.data.code === 0 || vipInfoRes.data.success) && vipInfoRes.data.data) {
        const { vipLevels } = vipInfoRes.data.data;
        this.vipCondition = vipLevels
          .filter(v => v.level > 0 && v.level <= 12)
          .sort((a, b) => a.level - b.level)
          .map(v => v.requiredExperience);
        this.lastViplevel = 12 - 1;
      }
      if ((vipCasesRes.data.code === 0 || vipCasesRes.data.success) && vipCasesRes.data.data) {
        const cases = vipCasesRes.data.data.cases || [];
        const upgradeCases = {};
        const weeklyCases = {};
        cases.forEach(c => {
          if (c.useType === 13) upgradeCases[c.vipLevel] = c;
          else if (c.useType === 14) weeklyCases[c.vipLevel] = c;
        });
        this.vipUpgradeCases = upgradeCases;
        this.vipWeeklyCases = weeklyCases;
      }
    } catch (e) {
      console.error('vip init error', e);
    }
  },
  methods: {
    ...mapMutations(["setInfo"]),
    openUpgradeCase(level) {
      const c = this.vipUpgradeCases[level];
      if (c) this.$router.push({ name: 'case', params: { id: c.id } });
    },
    openWeeklyCase(level) {
      const c = this.vipWeeklyCases[level];
      if (c) this.$router.push({ name: 'case', params: { id: c.id } });
    },
    GotoReceive(i) {
      if (this.user.vipLevel >= i) {
        this.$emit('onSwtichTab', { routerPush: 'redEnvelope' });
      } else {
        this.$store.commit("setPayModal", true);
      }
    },
    GotoRecvWeekly(i) {
      if (this.user.vipLevel == i) {
        this.$emit('onSwtichTab', { routerPush: 'redEnvelope' });
      } else {
        //this.$store.commit("setPayModal",true);
        this.$toast.error("当前 VIP 等级资格不符");
      }
    },
  },
};
